import cn from 'classnames'
import { Fragment, type ReactNode } from 'react'

import styles from './CockpitBreadcrumb.module.scss'

export interface ICockpitBreadcrumbCrumb {
  id: string
  label: ReactNode
}
interface IProps {
  rootLabel: ReactNode
  ariaLabel: string
  crumbs: ICockpitBreadcrumbCrumb[]
  current?: ReactNode
  currentBadge?: ReactNode
  className?: string
  /** -1 opens the root; other indices identify a crumb. */
  onNavigate: (index: number) => void
}

export const CockpitBreadcrumb = ({
  rootLabel,
  ariaLabel,
  crumbs,
  current,
  currentBadge,
  className,
  onNavigate,
}: IProps) => (
  <nav className={cn(styles.root, className)} aria-label={ariaLabel}>
    <button type="button" className={styles.step} onClick={() => onNavigate(-1)}>
      <span aria-hidden>&larr;</span> {rootLabel}
    </button>
    {crumbs.map((crumb, index) => (
      <Fragment key={crumb.id}>
        <span className={styles.separator}>&middot;</span>
        <button type="button" className={styles.step} onClick={() => onNavigate(index)}>
          {crumb.label}
        </button>
      </Fragment>
    ))}
    {current && (
      <>
        <span className={styles.separator}>&middot;</span>
        {currentBadge}
        <span className={styles.current}>{current}</span>
      </>
    )}
  </nav>
)

CockpitBreadcrumb.displayName = 'CockpitBreadcrumb'
